import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="reports"
export default class extends Controller {
  submit() {
    this.element.requestSubmit();
  }

  showAllGames() {
    if (this.element.id == "show-all-games-top-ggr-today") {
      this.element.style.display = "none";
      document.querySelector(".all-games-top-ggr-today").style.display = "block";
    } else if(this.element.id == "show-all-games-top-loss-today") {
      this.element.style.display = "none";
      document.querySelector(".all-games-top-loss-today").style.display = "block";
    } else if(this.element.id == "show-all-games-top-ggr-yesterday") {
      this.element.style.display = "none";
      document.querySelector(".all-games-top-ggr-yesterday").style.display = "block";
    } else if(this.element.id == "show-all-games-top-loss-yesterday") {
      this.element.style.display = "none";
      document.querySelector(".all-games-top-loss-yesterday").style.display = "block";
    }
  }
}
